/**
 * Zone.js 性能优化标志
 * 禁用不需要的 Zone.js 补丁以减少包体积和提升运行时性能
 * 这些标志需要在 zone.js 加载之前设置
 */

// 禁用 Web Components 自定义元素的 Zone.js 补丁（项目未使用 Web Components）
(window as any).__Zone_disable_customElements = true;

// 禁用对 requestAnimationFrame 的补丁 — 减少不必要的变更检测
// 注意：如果应用中有依赖 rAF 触发变更检测的场景，请注释掉此行
// (window as any).__Zone_disable_requestAnimationFrame = true;

// 禁用 mousemove/scroll 等高频事件的 Zone.js 补丁以提升滚动性能
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'touchmove', 'pointermove', 'wheel'];
